import { useMemo, useCallback } from "react";
import { useDropzone, DropzoneRootProps, Accept } from "react-dropzone";
import { baseStyle, activeStyle, acceptStyle, rejectStyle } from "./dropzoneStyles";

type Props = {
    handleSetFile: (file: File) => void;
    msg: string;
    accept?: Accept;
};

export const FileDropzone = ({ handleSetFile, msg, accept }: Props) => {
    const onDrop = useCallback(
        acceptedFiles => {
            handleSetFile(acceptedFiles[0]);
        },
        [handleSetFile]
    );
    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
        accept: accept,
        onDrop,
        maxFiles: 1,
    });

    const style: DropzoneRootProps = useMemo(
        () => ({
            ...baseStyle,
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isDragActive, isDragReject, isDragAccept]
    );
    return (
        <div className="file-dropzone-container">
            <div {...getRootProps({ style })}>
                <input {...getInputProps()} />
                {msg}
            </div>
        </div>
    );
};
